export const COLOURS = [
  {
    id: 'auto',
    value: 'var(--card-text-color)',
  },
  {
    id: 'black',
    value: '#171717',
  },
  {
    id: 'white',
    value: '#FFFFFF',
  },
  {
    id: 'green',
    value: '#A2FB91',
  },
  {
    id: 'pink',
    value: '#F4B5B4',
  },
  {
    id: 'purple',
    value: '#A0B5F8',
  },
  {
    id: 'yellow',
    value: '#F8EFA2',
  },
  {
    id: 'blue',
    value: '#A2EEFD',
  },
];
